import { normalizeImageUrl } from "./imageUrl";

const VIDEO_EXTENSIONS = /\.(mp4|webm|ogg)$/i;
const CLOUDINARY_VIDEO_UPLOAD = 'video/upload';

export const isVideoUrl = (url) => {
  if (!url) return false;
  return VIDEO_EXTENSIONS.test(url) || url.includes(CLOUDINARY_VIDEO_UPLOAD);
};

export const MediaPreview = ({ url, alt = 'Preview', className = '' }) => {
  if (!url) return null;
  const normalizedUrl = normalizeImageUrl(url);

  return isVideoUrl(normalizedUrl) ? (
    <video src={normalizedUrl} controls className={className} />
  ) : (
    <img src={normalizedUrl} alt={alt} className={className} />
  );
};
